/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import DrawerCaretIcon from '../../icons/utility/DrawerCaret';
import DrawerCaretFlippedIcon from '../../icons/utility/DrawerCaretFlipped';

import {
  DivItemContainerStyled,
  DtItemContainer,
  ButtonContainerStyled,
  DdItemContainer,
  TypographyContentStyled,
  TypographyTitleStyled,
  Styles,
} from './styles';

export const AccordionComponent = ({
  id,
  items,
  firstItemOpen,
  titleTypographyProps,
  toggleOpenIcon,
  toggleCloseIcon,
  variant,
}) => {
  const styles = Styles();
  const [openedIndex, setOpenedIndex] = useState(firstItemOpen ? 0 : null);

  const ToggleOpenIconComponent = toggleOpenIcon;
  const ToggleCloseIconComponent = toggleCloseIcon;

  const accordianItemTitleTypographyVariant = variant === 'primary' ? 'p' : 'h3';
  const accordianItemTitleTypographyWeight = variant === 'primary' ? 400 : 500;
  const iconWidth = variant === 'primary' ? 25 : 30;
  const iconHeight = variant === 'primary' ? 25 : 30;

  useEffect(() => {
    // validate all descriptionListData passed in are correct
    if (items.length === 0) {
      console.error('Missing drawer list data. At least one entry is required.');
    }
  }, []);
  return (
    <dl id={id}>
      {items.map((item, index) => (
        <DivItemContainerStyled
          key={`${item.title}-${index}`}
          id={`container-${item.id}`}
          variant={variant}>
          <DtItemContainer id={`dt-container-${item.id}`}>
            <ButtonContainerStyled
              id={`dt-button-${item.id}`}
              variant={variant}
              onClick={() => {
                setOpenedIndex(index === openedIndex ? null : index);
              }}
              aria-expanded={openedIndex === index ? 'true' : 'false'}
              className={
                openedIndex === index ? 'is-accordion-item-expanded' : ''
              }>
              {item.icon && <item.icon style={styles.TitleIconStyled} />}
              <TypographyTitleStyled
                disableBottomPadding
                variant={accordianItemTitleTypographyVariant}
                weight={accordianItemTitleTypographyWeight}
                component="h3"
                align="left"
                id={`dt-title-${item.id}`}
                {...titleTypographyProps}
                leftPadding={!!item.icon}>
                {item.title}
              </TypographyTitleStyled>
              {openedIndex ? (
                <ToggleCloseIconComponent
                  style={styles.IconToggleStyled(variant)}
                  height={iconHeight}
                  width={iconWidth}
                  className="accordion-toggle-icon"
                />
              ) : (
                <ToggleOpenIconComponent
                  style={styles.IconToggleStyled(variant)}
                  height={iconHeight}
                  width={iconWidth}
                  className="accordion-toggle-icon"
                />
              )}
            </ButtonContainerStyled>
          </DtItemContainer>
          <DdItemContainer
            style={{ display: openedIndex === index ? 'block' : 'none' }}
            id={`dd-container-${item.id}`}>
            <TypographyContentStyled
              as={item.contentAs || 'p'}
              disableBottomPadding>
              {item.content}
            </TypographyContentStyled>
          </DdItemContainer>
        </DivItemContainerStyled>
      ))}
    </dl>
  );
};

AccordionComponent.propTypes = {
  id: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(['primary', 'secondary']),
  /** The icon displayed to toggle a drawer list item */
  toggleOpenIcon: PropTypes.any,
  /** The icon displayed to toggle a drawer list item */
  toggleCloseIcon: PropTypes.any,
  /** Any prop overrides to apply to the title text in the dt element */
  titleTypographyProps: PropTypes.object,
  /** Array of accoladed to display in the section */
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      /** Icon to display in front of title */
      icon: PropTypes.any,
      /** The 'id' of the accolade wanting to display */
      title: PropTypes.string.isRequired,
      /** The sup number corresponding with the footer reference, Required for descriptionListData needing source to cite */
      content: PropTypes.any.isRequired,
    }),
  ).isRequired,
  /** Default open the first drawer item */
  firstItemOpen: PropTypes.bool,
};

AccordionComponent.defaultProps = {
  variant: 'primary',
  toggleOpenIcon: DrawerCaretIcon,
  toggleCloseIcon: DrawerCaretFlippedIcon,
  titleTypographyProps: {},
  firstItemOpen: false,
};

export default AccordionComponent;
